module.exports = __webpack_public_path__ + "img/placeholder.5e2191e6.jpg";